import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FaPhone } from 'react-icons/fa';
import './StickyCTABar.css';

const HIDDEN_ROUTES = ['/unsubscribe', '/privacy-policy', '/terms', '/shmetrix-privacy-policy'];

function track(event, location) {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', event, { location });
  }
  if (event === 'sticky_bar_click' && location === 'call' && typeof window !== 'undefined' && window.fbq) {
    window.fbq('trackCustom', 'DemoCallClick', { location: 'sticky_bar' });
  }
}

function StickyCTABar() {
  const { pathname } = useLocation();
  const [scrolled, setScrolled] = useState(false);
  const [blocked, setBlocked] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.pageYOffset > 200);
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  // Hide while the audit form or the footer is on screen
  useEffect(() => {
    const targets = [
      document.getElementById('audit-form'),
      document.querySelector('footer'),
    ].filter(Boolean);
    if (!targets.length) {
      setBlocked(false);
      return undefined;
    }
    const visible = new Set();
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) visible.add(entry.target);
        else visible.delete(entry.target);
      });
      setBlocked(visible.size > 0);
    });
    targets.forEach((t) => observer.observe(t));
    return () => observer.disconnect();
  }, [pathname]);

  if (HIDDEN_ROUTES.some((r) => pathname.startsWith(r))) return null;

  return (
    <div className={`sticky-cta-bar ${scrolled && !blocked ? 'visible' : ''}`}>
      <a
        href="tel:+14244344541"
        className="sticky-cta-call"
        onClick={() => track('sticky_bar_click', 'call')}
      >
        <FaPhone aria-hidden="true" /> Call the AI demo
      </a>
      <Link
        to="/free-missed-lead-audit"
        className="sticky-cta-audit"
        onClick={() => track('sticky_bar_click', 'audit')}
      >
        Free audit
      </Link>
    </div>
  );
}

export default StickyCTABar;
